import { NextPage } from 'next'
import dynamic from 'next/dynamic'
import { getIDeviceComponent } from '@ucheba/utils/helpers/components'
import { IObjectDevicesComponents } from '@ucheba/utils/helpers/components/types'
import React from 'react'
import { NextSeo } from 'next-seo'
import { useDispatch } from 'react-redux'
import { ESchoolPageTypes } from '../../school/index/types'
import { IIndexOgePageProps } from './types'
import { getJsonLdElement } from '../../../../../utils/helpers/getJsonLdElement'
import { useShowPhoneAndMessengers } from '../../../../../utils/hooks/useShowPhoneAndMessengers'
import { footerNavSchoolLinks } from '../../school/index/constants'
import { headerActions } from '../../../../components/Header/store'
import { footerActions } from '../../../../components/Footer/store'
import { useConvertSchoolData } from '../../school/index/bll/useConvertSchoolData'

const devicesPages: IObjectDevicesComponents = {
  desktop: dynamic(() => import('./desktop/IndexOgePage')),
  touch: dynamic(() => import('./touch/IndexOgePage')),
}

const IndexOgePage: NextPage<IIndexOgePageProps> = (props) => {
  const { canonical, data } = props
  const { content } = useConvertSchoolData(data, { type: ESchoolPageTypes.oge })
  const JsonElement = getJsonLdElement(content?.seo?.jsonLd || '')
  const dispatch = useDispatch()
  const isShowPhoneAndMessengers = useShowPhoneAndMessengers()

  if (!isShowPhoneAndMessengers) {
    const item = footerNavSchoolLinks[0]
    dispatch(headerActions.showPhone(false))
    dispatch(footerActions.setShowMessengers(false))
    dispatch(footerActions.setNavLinks([item]))
  } else {
    dispatch(headerActions.showPhone(true))
    dispatch(footerActions.setShowMessengers(true))
    dispatch(footerActions.setNavLinks(footerNavSchoolLinks))
  }

  return (
    <>
      <NextSeo
        title={content?.seo?.title}
        description={content?.seo?.description}
        canonical={canonical}
        openGraph={{
          images: [
            {
              url: content?.seo?.image || '',
              width: 1200,
              height: 630,
            },
          ],
        }}
      />

      {JsonElement}

      {getIDeviceComponent({ ...props, content }, devicesPages)}
    </>
  )
}

export default IndexOgePage
